jQuery(document).ready(function( $ ) {

    $('.mobile-navigation__toggle').click(function() {
        $('.mobile-navigation__wrapper').toggleClass('active');
    });

});

jQuery(window).on('beforeunload', function() {
    jQuery('.mobile-navigation__wrapper').removeClass('active');
});